import {TableDefinition} from "../table/table-definition";
import {TableModel} from "../table/table-model";
import {ContentModel} from "./content-model";
import {ViewDefinition} from "../view/view-definition";
import {ViewModel} from "../view/view-model";
import {FormDisplayType} from "../type/form-display-type.enum";

export class DetailContentModel extends ContentModel {
  private readonly detailViewModel; // This is the view model that comes across when a detail form is loaded.

  constructor(viewDefinitionOrModel: ViewDefinition | ViewModel, tableDefinitionOrModel: TableDefinition | TableModel, data?: any) {
    super(viewDefinitionOrModel, tableDefinitionOrModel, data.data);
    this.viewModel.setFormDisplayType(FormDisplayType.FORM);
    this.detailViewModel = data;
  }

  getDetailViewModel(): any {
    return this.detailViewModel;
  }

  update(data: any, retainFieldValues?: boolean) {
    // Update the mapped DetailViewModel was originally got from the server
    this.detailViewModel._update(data, retainFieldValues);
    // Copy across the data section as in the constructor
    this.data = this.detailViewModel.data;
    // Tell anyone interested that the content model has now changed.
    this.changed$.next("refresh");

    // Update the footers with a broadcast as the .next() above does not trigger the main footer when a button
    // on a required fields modal is clicked.
    const messageBus = (window as any).MessageBus;
    const id = typeof this.data.id === "function" ? this.data.id() : this.data.id;
    messageBus.publish(messageBus.CHANNELS.FORM_API_EVENT, `footer.reload`, { id: id });
  }
}
